import { Component, inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginFormComponent } from '../../components/login-form/login-form.component';
import { AuthModalService } from '../../services/auth-modal.service';

@Component({
  selector: 'eng-login-modal',
  imports: [ReactiveFormsModule, LoginFormComponent],
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.scss',
})
export class LoginModalComponent {
  public readonly activeModal = inject(NgbActiveModal);
  private readonly authModalService = inject(AuthModalService);

  @Input() returnUrl = '';

  onSwitchToRegister(): void {
    this.activeModal.dismiss();
    // Open register modal
    setTimeout(() => {
      this.authModalService.openRegisterModal(this.returnUrl);
    }, 100);
  }

  onForgotPassword(): void {
    this.activeModal.dismiss();
    // Navigate to the Angular forgot password page
    window.location.href = '/account/forgot-password';
  }
}
